/**
 * Colaborador = e-mail terminado em @nasajon.com.br. Capability só existe para colaborador: a API ignora as roles de
 * quem é de fora (mesmo que estejam no token) e o front faz o mesmo, para não mostrar nem liberar o que ela barraria.
 */
export const DOMINIO_COLABORADOR = '@nasajon.com.br';

export function ehColaborador(identificador: string | null | undefined): boolean {
  return (identificador ?? '').trim().toLowerCase().endsWith(DOMINIO_COLABORADOR);
}
